// Arquivo gerado automaticamente, não editar!

export const ROLE_ADMIN = 'admin';
export const ROLE_TESTE = 'teste';
export const ROLE_FREE = 'free';
export const ROLE_PREMIUM = 'premium';
export const ROLE_CLIENT = 'client';

export const PERMISSION_USERS_EDIT_OTHER_USERS = 'users.edit_other_users';
export const PERMISSION_USERS_EDIT_SELF = 'users.edit_self';
export const PERMISSION_USERS_ADD_BASEUSER = 'users.add_baseuser';
export const PERMISSION_USERS_ADD_INVITE = 'users.add_invite';
export const PERMISSION_USERS_LIST_INVITE = 'users.list_invite';
export const PERMISSION_USERS_DELETE_BASEUSER = 'users.delete_baseuser';
export const PERMISSION_USERS_LIST_BASEUSER = 'users.list_baseuser';
export const PERMISSION_USERS_VIEW_VISAO_MERCADO = 'users.view_visao_mercado';
export const PERMISSION_USERS_VIEW_MATRICULAS_SERIE =
  'users.view_matriculas_serie';
export const PERMISSION_USERS_VIEW_RAIO_INFLUENCIA =
  'users.view_raio_influencia';
export const PERMISSION_USERS_VIEW_ANALISAR = 'users.view_analisar';
export const PERMISSION_USERS_VIEW_ANALISAR_ESCOLA =
  'users.view_analisar_escola';
export const PERMISSION_USERS_VIEW_TURMAS_SEGMENTOS =
  'users.view_turmas_segmentos';
export const PERMISSION_USERS_VIEW_COMPARAR_ESCOLAS =
  'users.view_comparar_escolas';
export const PERMISSION_USERS_VIEW_COMPARAR_ESCOLAS_ALUNOS_POR_SEGMENTO =
  'users.view_comparar_escolas_alunos_por_segmento';
export const PERMISSION_USERS_VIEW_COMPARAR_ESCOLAS_EVOLUCAO_MATRICULAS =
  'users.view_comparar_escolas_evolucao_matriculas';
export const PERMISSION_USERS_VIEW_ESCOLAS_ENEM = 'users.view_escolas_enem';
export const PERMISSION_PNAE_VIEW_REAJUSTEPNAE = 'pnae.view_reajustepnae';

export const PERMISSION_GROUP_MAP = {
  'pnae.view_reajustepnae': ['admin', 'premium', 'client'],
  'users.add_baseuser': ['admin'],
  'users.add_invite': ['admin'],
  'users.delete_baseuser': ['admin'],
  'users.edit_other_users': ['admin'],
  'users.edit_self': ['admin', 'teste'],
  'users.list_baseuser': ['admin'],
  'users.list_invite': ['admin'],
  'users.view_analisar': ['admin', 'free', 'premium', 'client'],
  'users.view_analisar_escola': ['admin', 'premium', 'client'],
  'users.view_comparar_escolas': ['admin', 'free', 'premium', 'client'],
  'users.view_comparar_escolas_alunos_por_segmento': [
    'admin',
    'premium',
    'client',
  ],
  'users.view_comparar_escolas_evolucao_matriculas': [
    'admin',
    'premium',
    'client',
  ],
  'users.view_escolas_enem': ['admin', 'premium', 'client'],
  'users.view_matriculas_serie': ['admin', 'premium', 'client'],
  'users.view_raio_influencia': ['admin', 'client'],
  'users.view_turmas_segmentos': ['admin', 'premium', 'client'],
  'users.view_visao_mercado': ['admin', 'free', 'premium', 'client'],
};
